import img1 from '../assets/images/thumbnail1.png';
import img2 from '../assets/images/thumbnail2.png';
import img3 from '../assets/images/thumbnail3.png';
import img4 from '../assets/images/thumbnail4.png';

export const projects = [
  {
    title: 'Web Developement',
    project: [
      {
        image: img1,
        view: '',
        live: '',
        title: 'Card Printing',
        desc: 'Card printing software reduce hallmarking card generating process from 16 minutes to less than 4 minutes. 🎴',
        tags: ['JavaScript', 'HTML', 'ReactJs', 'Axios'],
      },
      {
        image: img2,
        view: '',
        live: '',
        title: 'Cointra',
        desc: 'CoinTra is a cryptocurrency price tracker app 🪙',
        tags: ['JavaScript', 'HTML', 'CSS'],
      },
      {
        image: img3,
        view: '',
        live: '',
        title: 'Imo',
        desc: 'imo is a image classification website where user can upload images and it will classify images into their respective category 📸',
        tags: ['Django', 'JavaScript', 'HTML', 'CSS'],
      },
      {
        image: img4,
        view: '',
        live: '',
        title: 'Drone Website',
        desc: 'A drone website landing page using React and Three.js 🛸',
        tags: ['Django', 'JavaScript', 'HTML', 'CSS'],
      },
    ],
  },
];
